import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPlay } from 'react-icons/fa';
import { initialBlogs } from '../../utils/addInitialBlogs';

const FirstStep = () => {
    const navigate = useNavigate();

    const handleBlogClick = (title) => {
        const blogIndex = initialBlogs.findIndex(b => b.title === title);
        if (blogIndex !== -1) {
            const blog = initialBlogs[blogIndex];
            const staticId = `static-${blogIndex + 1}`;
            // Navigate to blog detail page with blog data in state
            navigate(`/blogs/${staticId}`, {
                state: {
                    blog: {
                        ...blog,
                        id: staticId,
                        isStatic: true,
                        createdAt: blog.createdAt || new Date()
                    }
                }
            });
        } else {
            navigate('/blogs');
        }
    };

    return (
        <section className="section" style={{ backgroundColor: '#f9f9f9', overflow: 'hidden' }}>
            <div className="container">
                {/* Nyssa Brand Story Section */}


                <div className="split-section-container" style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    gap: '60px',
                    marginTop: '80px'
                }}>

                    {/* Left Side - OUR VISION */}
                    <div className="split-content-left" style={{ flex: '1 1 450px' }}>
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                        >
                            <h2 style={{
                                fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                marginBottom: '25px',
                                fontWeight: '700'
                            }}>
                                OUR VISION
                            </h2>

                            <div style={{
                                width: '60px',
                                height: '3px',
                                background: 'linear-gradient(90deg, var(--primary), #d4a5a5)',
                                marginBottom: '30px'
                            }}></div>

                            <p style={{
                                color: 'var(--text-light)',
                                lineHeight: '1.8',
                                fontSize: '1.15rem',
                                marginBottom: '0'
                            }}>
                                Nyssa, With you to uplift your intimate health and self esteem respectfully.
                            </p>
                        </motion.div>
                    </div>

                    {/* Right Side - OUR MISSION */}
                    <div style={{ flex: '1 1 450px', position: 'relative' }}>
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                        >
                            <h2 style={{
                                fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                marginBottom: '25px',
                                fontWeight: '700'
                            }}>
                                OUR MISSION
                            </h2>

                            <div style={{
                                width: '60px',
                                height: '3px',
                                background: 'linear-gradient(90deg, var(--primary), #d4a5a5)',
                                marginBottom: '30px'
                            }}></div>

                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '18px'
                            }}>
                                {[
                                    'To Make healthcare more humane.',
                                    'To Help people feel whole again & Not to fix them.',
                                    'To Create a space where people can finally exhale.',
                                    'To Create a judgement-free environment where people feel comfortable to speak',
                                    'To Help individuals heal with confidence Physically, Emotionally and Mentally   by Offering expert care with Empathy, Sensitivity and Respect. '
                                ].map((item, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, x: -20 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.5, delay: 0.2 + (index * 0.1) }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '15px'
                                        }}
                                    >
                                        <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: 'var(--primary)',
                                            flexShrink: 0,
                                            marginTop: '8px'
                                        }}></div>
                                        <span style={{
                                            fontSize: '1.1rem',
                                            color: 'var(--text-light)',
                                            lineHeight: '1.6'
                                        }}>
                                            {item}
                                        </span>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    </div>


                </div>




                {/* BLOG IDEAS Section */}
                <div style={{ marginTop: '100px' }}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 style={{
                            fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            marginBottom: '60px',
                            fontWeight: '700',
                            textAlign: 'center'
                        }}>
                            BLOG
                        </h2>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                            gap: '30px'
                        }}>
                            {[
                                'Why We Ignore Health Concerns and Why We Shouldn\'t',
                                'When Is It Time to See a Doctor for Intimate Health Issues?',
                                'Understanding Skin Changes: What\'s Normal and What\'s Not',
                                'Post-Pregnancy Body Changes Nobody Talks About',
                                'How Stress Affects Skin, Hair and Overall Health'
                            ].map((blog, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    style={{
                                        padding: '30px 25px',
                                        backgroundColor: 'var(--white)',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                        borderLeft: '4px solid var(--primary)',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    whileHover={{
                                        transform: 'translateY(-5px)',
                                        boxShadow: '0 8px 30px rgba(181, 131, 131, 0.15)',
                                        backgroundColor: '#fffafa'
                                    }}
                                    onClick={() => handleBlogClick(blog)}
                                >
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '15px'
                                    }}>
                                        <span style={{
                                            fontSize: '1.5rem',
                                            fontWeight: '700',
                                            color: 'var(--primary)',
                                            fontFamily: 'var(--font-heading)',
                                            flexShrink: 0,
                                            lineHeight: '1'
                                        }}>
                                            {index + 1}.
                                        </span>
                                        <h3 style={{
                                            fontSize: '1.1rem',
                                            color: 'var(--secondary)',
                                            lineHeight: '1.6',
                                            margin: 0,
                                            fontWeight: '600'
                                        }}>
                                            {blog}
                                        </h3>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Mobile Responsive Styles */}
            <style>{`
                @media (max-width: 768px) {
                    section div[style*="gap: 80px"] {
                        gap: 40px !important;
                        flex-direction: column !important;
                        margin-bottom: 60px !important;
                        padding: 30px 0 !important;
                    }

                    section div[style*="flex: '1 1 400px'"],
                    section div[style*="flex: '1 1 450px'"] {
                        flex: 1 1 100% !important;
                        text-align: center !important;
                    }

                    section h2 {
                        font-size: 2rem !important;
                        text-align: center !important;
                    }

                    section p {
                        font-size: 1.05rem !important;
                        text-align: center !important;
                    }

                    .split-section-container {
                        flex-direction: column !important;
                        gap: 40px !important;
                        margin-top: 50px !important;
                    }

                    .split-content-left {
                        text-align: center !important;
                    }

                    section div[style*="width: 60px"][style*="height: 3px"] {
                        margin: 0 auto 20px !important;
                    }

                    section div[style*="gridTemplateColumns"] {
                        grid-template-columns: 1fr !important;
                        gap: 20px !important;
                    }

                    section div[style*="padding: 30px 25px"] {
                        padding: 20px !important;
                    }

                    section div[style*="marginTop: '100px'"] {
                        margin-top: 60px !important;
                    }

                    section h3 {
                        font-size: 1.05rem !important;
                    }

                    section span[style*="fontSize: '1.5rem'"] {
                        font-size: 1.3rem !important;
                    }
                }
            `}</style>
        </section>
    );
};

export default FirstStep;
